import { Component, OnInit, ViewChild } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TransactionHistoryComponent extends BaseComponent implements OnInit {

  transactions: any[] = [];
  transactionsColumns: string[] = ['date', 'receiptNo', 'action'];

  dsTransactions!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;  
 
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
  expandedElement: any;

  ngOnInit() {
    this.app.pageTitle = 'Transaction History';
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();
      this.scrollTo();
      this.getTransactionHistory();
    });
    this.start();
  }

  backToLogin() {
    this.app.router.navigate([AppConstants.RouteLogin]);
  }

  getTransactionHistory() {
    this.app.spinner.show();
    this.app.webBookingService.GetTransactionHistory()
      .subscribe(
        data => {
          this.transactions = data == null ? [] : data;
          this.dsTransactions = new MatTableDataSource(this.transactions);
          setTimeout(() => {
            this.dsTransactions.paginator = this.paginator;
            this.dsTransactions.sort = this.sort;
            this.app.spinner.hide();
          }, 500);
          
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

}
